import { Observable } from 'rxjs';
import { AbstractControl } from '@angular/forms';

export type ReturnObservableDataType<T extends Observable<any>> = T extends Observable<
  infer U
>
  ? U
  : never;

export interface ApiResponseModelWrapper<T> {
  success: boolean;
  data: T;
  error?: string;
  reloadData?: boolean;
  redirectUrl?: string;
}

export enum LoadingState {
  Pending,
  Loaded,
  Failed,
}

export type FormControls<T> = {
  [key in keyof T]: AbstractControl;
};
